import { COMPANY_INFO } from '../config/company';
import { useLanguage } from '../config/language';

// Payment methods combined image
const PAYMENT_METHODS_IMAGE = 'https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/y2z0nkha_cqc.PNG';

export const Footer = () => {
  const { t, language } = useLanguage();
  const isAr = language === 'ar';
  
  return (
    <footer className="bg-[#0F172A] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/pggsc8pu_freepik__background__28286.png" 
              alt="CloudGM Logo" 
              className="h-24 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-[#94A3B8] text-sm">{t('footer.description')}</p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 font-heading">{t('footer.sections')}</h3>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li><a href="/properties" className="hover:text-[#1E9BD9]">{t('nav.realEstate')}</a></li>
              <li><a href="/marketplace" className="hover:text-[#1E9BD9]">{t('nav.marketplace')}</a></li>
              <li><a href="/spare-parts" className="hover:text-[#1E9BD9]">{t('nav.spareParts')}</a></li>
              <li><a href="/products" className="hover:text-[#1E9BD9]">{t('nav.products')}</a></li>
              <li><a href="/services" className="hover:text-[#1E9BD9]">{t('nav.services')}</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 font-heading">{t('footer.company')}</h3>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li><a href="/about-us" className="hover:text-[#1E9BD9]">{t('common.aboutUs')}</a></li>
              <li><a href="/support" className="hover:text-[#1E9BD9]" data-testid="footer-support-link">{isAr ? 'مركز الدعم' : 'Support Center'}</a></li>
              <li><a href="/terms" className="hover:text-[#1E9BD9]">{t('common.terms')}</a></li>
              <li><a href="/privacy-policy" className="hover:text-[#1E9BD9]">{t('common.privacyPolicy')}</a></li>
              <li><a href="/data-deletion" className="hover:text-[#1E9BD9]" data-testid="footer-data-deletion-link">{isAr ? 'حذف بيانات المستخدم' : 'User Data Deletion'}</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4 font-heading">{t('footer.contact')}</h3>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li>{t('common.email')}: {COMPANY_INFO.email}</li>
              <li>{t('common.phone')}: <span dir="ltr">{COMPANY_INFO.phoneDisplay}</span></li>
              <li>{isAr ? COMPANY_INFO.address.full : COMPANY_INFO.address.fullEn}</li>
            </ul>
          </div>
        </div>

        {/* Payment Methods Section */}
        <div className="border-t border-[#1E293B] mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-sm text-[#64748B]">
              {isAr ? 'وسائل الدفع المقبولة' : 'Accepted Payment Methods'}
            </p>
            <div className="bg-white rounded-full px-3 py-1">
              <img 
                src={PAYMENT_METHODS_IMAGE} 
                alt="Payment Methods - Visa, Mastercard, Google Pay, Apple Pay, Tabby, Tamara" 
                className="h-8 md:h-9 object-contain"
              />
            </div>
          </div>
        </div>
        
        <div className="border-t border-[#1E293B] mt-8 pt-8 text-center text-sm text-[#94A3B8]">
          <p>&copy; 2025 {COMPANY_INFO.name}. {t('common.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};
